import React from "react";
import { compose } from "recompose";
import { withForm } from "@manakin/core";
import ChangePasswordView from "./ChangePasswordView";

const form = {
	password: {
		format: "password",
		required: true,
	},
	secondPassword: {
		required: true,
		couple: "password",
		coupleLabel: "wachtwoord",
		format: "password",
	},
};

const PasswordView = (props) => {
	const { form, onSubmit } = props;

	return <ChangePasswordView form={form} onSubmit={onSubmit} />;
};

export default compose(withForm(form))(PasswordView);
